import { render, staticRenderFns } from "./UserRequisites.vue?vue&type=template&id=0960ffcb&"
import script from "./UserRequisites.vue?vue&type=script&lang=js&"
export * from "./UserRequisites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports